// constants
import VideoEvent from '../../../assets/js/constants/video-event';

export default class HeroHome {

	static selector = 'hero-home';

	// class variables

	el = {};

	// constructor

	constructor(container) {
		this.el = {
			container,
			videoPlayer: container.querySelector(`.${this.constructor.selector}__video-player`),
			videoPlayerWrapper: container.querySelector(`.${this.constructor.selector}__video-player-wrapper`),
			videoLooping: container.querySelector(`.${this.constructor.selector}__video-looping video`)
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add and remove listeners

	#addEventListeners = () => {
		if (this.el.videoPlayer) {
			this.el.videoPlayer.addEventListener(VideoEvent.LOADING_SUCCESS, this.#onVideoPlayerLoad);
			this.el.videoPlayer.addEventListener(VideoEvent.PLAYING, this.#onVideoPlayerPlay);
		}
	}

	#removeEventListeners = () => {
		if (this.el.videoPlayer) {
			this.el.videoPlayer.removeEventListener(VideoEvent.LOADING_SUCCESS, this.#onVideoPlayerLoad);
			this.el.videoPlayer.removeEventListener(VideoEvent.PLAYING, this.#onVideoPlayerPlay);
		}
	}

	// listener methods

	#onVideoPlayerLoad = () => {
		this.videoPlayerEnable();
	}

	#onVideoPlayerPlay = () => {
		this.videoPlayerEnable();
	}

	//

	videoPlayerEnable() {
		this.el.videoPlayerWrapper.classList.add('is-video-active');

		if (this.el.videoLooping && this.el.videoLooping.currentSrc) {
			this.el.videoLooping.pause();
		}
	}

	videoPlayerDisable() {

	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
